export interface EmailVerificationBannerProps {
  /** The email address to render in the template */
  email: string;
}

export enum EmailVerificationToastType {
  RESEND_EMAIL = 'resend_email',
  UPDATE_EMAIL = 'update_email'
}
